module.exports = __webpack_public_path__ + "img/loading_ob_border.c5db118.gif";